import classNames from 'classnames/bind';
import React from 'react';

import Attitude from './Attitude';
import GPSRaw from './GPSRaw';
import styles from './Monitor.module.scss';

import { EKFStatus, Tabs, Vibration } from '@/components/ui/dashboard/Monitor';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  return (
    <div className={cx('container')}>
      <Tabs tabs={['Attitude', 'GPS Raw', 'EKF Status', 'Vibration']}>
        <Attitude data={robotId} className={cx('attitude')} />
        <GPSRaw data={robotId} />
        <EKFStatus data={robotId} />
        <Vibration data={robotId} />
      </Tabs>
    </div>
  );
};

export default Monitor;
